import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { doc, updateDoc } from 'firebase/firestore';
import { db, functions } from '../firebase';
import { IconDiamond, IconX, IconBrandStrava, IconCheck } from '@tabler/icons-react';

const AutoAppendChallengePopup = ({ user, configId, challengeName, destination, previewMessage, alreadyEnabled, onClose, onEnabled }) => {
  const [claiming, setClaiming] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleEnable = async () => {
    setClaiming(true);
    try {
      const claimFunc = httpsCallable(functions, 'claimAutoAppendCredits');
      const result = await claimFunc({ configId });
      if (result.data?.success || result.data?.error === 'Auto-append challenge credits already claimed') {
        setSuccess(true);
        setTimeout(() => {
          onEnabled();
        }, 1500);
      }
    } catch (err) {
      console.error('Failed to claim auto-append credits:', err);
    } finally {
      setClaiming(false);
    }
  };

  const handleDismiss = async () => {
    try {
      const userDocRef = doc(db, 'users', user.uid);
      await updateDoc(userDocRef, {
        'settings.autoAppendPopupDismissed': true
      });
    } catch (err) {
      console.error('Failed to dismiss auto-append popup:', err);
    }
    onClose();
  };

  if (success) {
    return (
      <div className="join-modal-overlay" onClick={onClose}>
        <div className="join-modal auto-append-modal" onClick={e => e.stopPropagation()}>
          <div className="auto-append-success">
            <div className="auto-append-success-icon">
              <IconCheck size={32} />
            </div>
            <h3>Enabled!</h3>
            <p>You earned 5 diamonds <IconDiamond size={16} style={{ verticalAlign: 'middle' }} /></p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="join-modal-overlay" onClick={handleDismiss}>
      <div className="join-modal auto-append-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={handleDismiss}>
          <IconX size={20} />
        </button>

        <div className="auto-append-badge">
          <IconDiamond size={16} />
          <span>Earn 5 diamonds</span>
        </div>

        <div className="auto-append-icon">
          <IconBrandStrava size={32} />
        </div>

        <h3 className="auto-append-title">
          {alreadyEnabled
            ? 'Thanks for sharing on Strava!'
            : 'Share your challenge progress on Strava'
          }
        </h3>

        <p className="auto-append-description">
          {alreadyEnabled
            ? `You're already sharing your progress — claim your 5 diamonds as a thank you!`
            : `Every challenge activity gets a progress card uploaded to Strava and a progress note in the description.`
          }
        </p>

        {!alreadyEnabled && (
          <ul className="auto-append-bullets">
            <li><span className="auto-append-bullet-icon">🖼️</span> A visual card with the latest checkpoint art, your progress, and the route name.</li>
            <li><span className="auto-append-bullet-icon">📝</span> A short progress note appended to your activity description.</li>
          </ul>
        )}

        {previewMessage && (
          <div className="auto-append-preview">
            <p>{previewMessage}</p>
          </div>
        )}

        <button
          className="join-submit-button"
          onClick={handleEnable}
          disabled={claiming}
        >
          {claiming
            ? 'Claiming...'
            : alreadyEnabled
              ? 'Claim 5 💎'
              : 'Enable & Earn 5 💎'
          }
        </button>

        <button className="onboarding-skip-btn" onClick={handleDismiss}>
          No thanks
        </button>
      </div>
    </div>
  );
};

export default AutoAppendChallengePopup;
